module.exports = __webpack_public_path__ + "img/posterSearch-des4.9c3309b2.png";